import BasePageLayout from './BasePageLayout';
import BasePageLayoutContainer from './BasePageLayout.container';

export default BasePageLayoutContainer(BasePageLayout);
